/*
  This example requires Tailwind CSS v2.0+ 
  
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/typography'),
    ],
  }
  ```
*/
import About from '../../../../images/about.jpg'
export default function Example() {
    return (
      <div className="relative bg-white">
        <div className="lg:absolute lg:inset-0">
          <div className="lg:absolute lg:inset-y-0 lg:left-0 lg:w-1/2 ">
            <img
              className="h-56 w-full object-cover lg:absolute lg:h-full h-full"
              src={About}
              alt=""
            />
          </div>
        </div>
        <div className="relative pt-12 pb-16 px-4 sm:pt-16 sm:px-6 lg:px-8 lg:max-w-7xl lg:mx-auto lg:grid lg:grid-cols-2">
          <div className="lg:col-start-2 lg:pl-8">
            <div className="text-base max-w-prose mx-auto lg:max-w-lg lg:ml-auto lg:mr-0">
              <h2 className="leading-6 text-red-600 font-semibold tracking-wide uppercase">À propos de nous.</h2>
              <h3 className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl" data-aos="fade-down">
                Qui sommes-nous?
              </h3>
              <p className="mt-8 text-lg text-gray-500" data-aos="fade-right">
                Les infirmiers des voies publiques IVP est une asbl congolaise de solidarité, 
                nous donnons des soins médicaux de premières nécessités gratuits.
              </p>
              <p className="mt-8 text-lg text-gray-500" data-aos="fade-right">
                Nous constatons que la situation sanitaire des enfants vivant 
                dans la rue (Enfants abandonnés ou rejetés par leurs familles, les orphelins et les enfants accusés de sorcellerie) 
                et les enfants en placement dans des établissements pénitentiaires est très précaire et problématique.
              </p>
              <p className="mt-8 text-lg text-gray-500" data-aos="fade-right">
                Ces enfants, abandonnés à leur triste sort, sans aucun soutien, n'ont pas accès aux soins de santé et 
                luttent souvent contre des maladies chroniques qui des fois les conduisent à la mort.
              </p>
              <p className="mt-8 text-lg text-gray-500" data-aos="fade-right">
                Actuellement, nous exerçons dans la ville de Mbujimayi, 
                l'une des villes regorgeant le plus grand nombre de ces enfants.
              </p>
              {/*  */}
              <h3 className="mt-8 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl" data-aos="fade-down">
                Notre mission
              </h3>
              <ul className="mt-8 list-disc list-inside text-lg text-gray-500 space-y-6" >
                <li data-aos="fade-right">Administrer les soins infirmiers auxdits enfants;</li>
                <li data-aos="fade-right">Distribuer les médicaments de première nécessité aux orphelinats;</li>
                <li data-aos="fade-right">Prendre en charge les frais médicaux desdits enfants pour les cas qui nécessitent les soins dans une institution hospitlière;</li>
                <li data-aos="fade-right">Implanter une représentation dans les villes où se trouve un plus grand nombre des enfants en situation de rue;</li>
              </ul>
              {/* <div className="mt-5 prose prose-red text-gray-500">
                <p>
                  Sollicitudin tristique eros erat odio sed vitae, consequat turpis elementum. Lorem nibh vel, eget
                  pretium arcu vitae. Eros eu viverra donec ut volutpat donec laoreet quam urna.
                </p>
                <p>
                  Bibendum eu nulla feugiat justo, elit adipiscing. Ut tristique sit nisi lorem pulvinar. Urna, laoreet
                  fusce nibh leo. Dictum et et et sit. Faucibus sed non gravida lectus dignissim imperdiet a.
                </p>
                <p>
                  Dictum magnis risus phasellus vitae quam morbi. Quis lorem lorem arcu, metus, egestas netus cursus. In.
                </p>
                <ul role="list">
                  <li>Quis elit egestas venenatis mattis dignissim.</li>
                  <li>Cras cras lobortis vitae vivamus ultricies facilisis tempus.</li>
                  <li>Orci in sit morbi dignissim metus diam arcu pretium.</li>
                </ul>
                <p>
                  Rhoncus nisl, libero egestas diam fermentum dui. At quis tincidunt vel ultricies. Vulputate aliquet
                  velit faucibus semper. Pellentesque in venenatis vestibulum consectetur nibh id. In id ut tempus
                  egestas. Enim sit aliquam nec, a. Morbi enim fermentum lacus in. Viverra.
                </p>
                <h3>How we’re different</h3>
                <p>
                  Tincidunt integer commodo, cursus etiam aliquam neque, et. Consectetur pretium in volutpat, diam.
                  Montes, magna cursus nulla feugiat dignissim id lobortis amet. Laoreet sem est phasellus eu proin massa,
                  lectus. Diam rutrum posuere donec ultricies non morbi. Mi a platea auctor mi.
                </p>
                <p>
                  Mauris ullamcorper imperdiet nec egestas mi quis quam ante vulputate. Vel faucibus adipiscing lacus,
                  eget. Nunc fermentum id tellus donec. Ut metus odio sit sit varius non nunc orci. Eu, mi neque, ornare
                  suspendisse amet, nibh. Facilisi volutpat lectus id sapien dis mauris rhoncus. Est rhoncus, interdum
                  imperdiet ac eros, diam mauris, tortor. Risus id sit molestie magna.
                </p>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    )
  }
  